import { Box, Typography, styled } from "@mui/material";
import { colors, fonts } from "../../../../assets/styles/theme.ts";

export const Styled = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
  height: 100%;
  .styledTables {
    .MuiTableCell-root {
      padding: 6px;
    }
  }
`;
export const StyledTypography = styled(Typography)`
  font-family: ${fonts.primary};
  color: ${colors.blueDark};
  font-weight: 600;
  font-size: 20px;
`;
export const BoxInputs = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;
  width: 92%;
  .MuiBox-root {
    .divInput {
      width: 25%;
    }
  }
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    .MuiBox-root {
      flex-direction: column;
      width: 100%;
    .divInput {
      width: 100%;
      }
    }
}
`;
export const BoxHeader = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
  }
`;
export const BoxSubHeader = styled(Box)`
  display: flex;
  justify-content: space-between;
  .MuiBox-root {
    display: flex;
    gap: 5px;
  }
  @media (max-width: 768px) {
    flex-direction: column;
    .MuiBox-root:nth-of-type(1) {
      flex-direction: column;
    }
  }
`;
